import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';
import Button from '__components/Button';
import { SettingsContentCard } from '__components/Card/Card';
import Notice from '__components/Kizen/Notice';

export const StyledSettingsContentCard = styled(SettingsContentCard)`
  margin: 20px auto 80px;
  padding: 25px;
`;

export const StyledNotice = styled(Notice)`
  white-space: pre-line;
`;

export const StyledWarning = styled(KizenTypography)`
  white-space: pre-line;
`;

export const StyledDeleteButton = styled(Button)`
  margin: 0;
  margin-top: 20px;
`;

export const StyledModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
